import {
  DescriptionCollaboOliveYoungReviewModuleFormType,
  DescriptionModuleFormType,
} from '@container/Challenge/NewChallengeForm/NewChallengeForm.types';
import { commonDescriptionModules } from '../../DescriptionModuleForm.constant';

export const validate = (
  descriptionModule: DescriptionModuleFormType[],
): { isValid: true } | { isValid: false; message: string } => {
  const target = descriptionModule.find(
    ({ type }) => type === 'COLLABO-OLIVEYOUNG-REVIEW',
  );
  if (!target) return { isValid: true };

  const {
    data: {
      price,
      originalPrice,
      productThumbnailImageUrl,
      reviewText,
      reviewImageUrls,
      subModule,
    },
  } = target as DescriptionCollaboOliveYoungReviewModuleFormType;

  if (!productThumbnailImageUrl)
    return {
      isValid: false,
      message: '상품 썸네일 이미지를 등록해주세요.',
    };

  if (price > originalPrice)
    return {
      isValid: false,
      message: '[상세모듈] 올리브영리뷰 가격이 정가보다 비쌉니다.',
    };

  if (!reviewText)
    return {
      isValid: false,
      message: '리뷰를 등록해주세요.',
    };

  if (reviewImageUrls.length === 0) {
    return {
      isValid: false,
      message: '리뷰 이미지를 등록해주세요.',
    };
  }

  if (reviewImageUrls.length > 3) {
    return {
      isValid: false,
      message: '리뷰 이미지는 3개까지만 등록 가능합니다.',
    };
  }

  for (let index = 0; index < subModule.length; index++) {
    const { type } = subModule[index];
    const module = commonDescriptionModules[type];
    const validationResult = module.validate(subModule);
    if (!validationResult.isValid) return validationResult;
  }

  return { isValid: true };
};
